/**
 * Core states will be in global scope even they are in core state module (i.e. not in the
 * isolated namespace) as they should be always appllication-level data accessed by various
 * feature modules.
 *
 */

import { Module, ActionContext, Payload } from 'vuex';
import { RootStoreState } from '@/store';
import jsEncrypt from '@/shared/jsEncrypt';
import ApiServiceWrapper from '@/shared/api-request.service';
import { currentUserKey } from '@/shared/msw-constants';
import { envCongif } from '@/shared/env.config';
import { DeviceHierarchy } from '@/shared/types/device-hierarchy.types';
import { UserList } from '@/shared/types/userlist.type';
import { BrowserTitlesConfig } from '@/shared/msw-app-title/type';
import { isGuestUser } from './shared/constant';
// import browserTitles from '@/shared/msw-app-title/browserTitlesDictionary';
export interface CoreStoreState {
  appVersion: { version: string; buildTime: string; gitCommit: string | null; };
  federatedEmailExtensions: string[];
  loading: boolean;
  userInfo: any;
  clientId: string;
  userId: string;
  globalTheme: string;
  pageViewWidth: number;
  helpContainerSlideVisible: boolean;
  alertSliderVisible: boolean;
  supportCaseSliderVisible : boolean;
  selectedHelpId: string[];
  msgQueue: InfoState[];
  hideNavToggle: string;
  loggedIn: boolean;
  loggedInFromMSW: boolean;
  appVersionContent: any;

  // added by crystdata

  devicePickerSlideVisible: boolean;
  navCollapsed: boolean;
  selectedTopTabItemId: string;
  tenant : string;
  selectedNavItemId: string;
  tenantName: string;
  deviceHierarchy: DeviceHierarchy[];
  tenantList: any[];
  arrTenantOptions: any[];
  productList : string[];
  appLocale: string;
  tenantSerial: string;
  navigateUrl: string;
  nsmBaseUrl: string;
  ccBaseUrl: string;
  tenantGroups: any;
  currentCcTenantId: string;
  wirelessBaseUrl: string;
  nsmTenentMode: string;
  nsmTenentID: string;
  reloadWidgets : any;
  tfaMode: string;
  seletedTitle: BrowserTitlesConfig;
  cartCount: number;
  pCLid: string;
  initial: {
    appVersion: { version: string; buildTime: string; gitCommit: string | null; };
    federatedEmailExtensions: string[];
    loading: boolean;
    userInfo: any;
    clientId: string;
    tenant : string;
    userId: string;
    globalTheme: string;
    pageViewWidth: number;
    helpContainerSlideVisible: boolean;
    alertSliderVisible: boolean;
    supportCaseSliderVisible : boolean;
    selectedHelpId: string[];
    msgQueue: InfoState[];
    hideNavToggle: string;
    loggedIn: boolean;
    loggedInFromMSW: boolean;
    appVersionContent: any;
    // added by crystdata
    devicePickerSlideVisible: boolean;
    navCollapsed: boolean;
    selectedTopTabItemId: string;
    selectedNavItemId: string;
    tenantName: string;
    deviceHierarchy: DeviceHierarchy[];
    tenantList: any[];
    arrTenantOptions: any[];
    productList : string[];
    appLocale: string;
    tenantSerial: string,
    navigateUrl: string,
    nsmBaseUrl: string;
    ccBaseUrl: string;
    tenantGroups: any;
    currentCcTenantId: string;
    wirelessBaseUrl: string;
    nsmTenentMode: string;
    nsmTenentID: string;
  };
  qsgComponentId: string;
  userList : UserList[];
  browserTitle: any[];
  isGuestBuyNowUser: boolean;
}

export const MUTATION_SELECT_TOP_TAB_ITEM = 'selectTopTabItem';
export const MUTATION_SET_NAV_COLLAPSED = 'setNavCollapsed';
export const MUTATION_STORE_PAGE_VIEW_WIDTH = 'storePageViewWidth';
export const MUTATION_SET_HELP_CONTAINER_SLIDE_VISIBLE = 'setHelpContainerSlideVisible';
export const MUTATION_SET_ALERT_CONTAINER = 'setAlertSliderVisible';
export const MUTATION_SET_SUPPORT_CASE_CONTAINER = 'setSupportCaseSliderVisible';
export const MUTATION_SET_HELP_CONTENT_ID = 'setHelpContentId';

/** mutations and actions added by Crystdata*/
export const MUTATION_SET_APP_LOCALE = 'setAppLocale';
// export const MUTATION_SELECT_TOP_TAB_ITEM = 'selectTopTabItem';
export const MUTATION_SELECT_NAV_ITEM = 'selectNavItem';
// export const MUTATION_SET_NAV_COLLAPSED = 'setNavCollapsed';
// End of code by crystdata
export const MUTATION_SET_QSG_COMPONENT_ID = 'setQsgComponentId';

export const MUTATION_SET_TFA_MODE = 'setTfaMode';
export interface StorePageViewWidthPayload extends Partial<Payload> {
  width: number;
}
export interface SelectTopTabItemPayload extends Partial<Payload> {
  navId: string;
}

export interface SetNavCollapsedPayload extends Partial<Payload> {
  collapse: boolean;
}

export interface SetHelpContainerSlideVisiblePayload extends Partial<Payload> {
  visible: boolean;
}
export interface SetAlertSliderVisiblePayload extends Partial<Payload> {
  visible: boolean;
}
export interface SetSupportCasesSliderVisiblePayload extends Partial<Payload> {
  visible: boolean;
}
export interface SetTFAModePayload extends Partial<Payload> {
  mode: string;
}

export interface SetHelpContentIdPayload extends Partial<Payload> {
  helpId: string[];
}

export interface InfoState { infoType: string; infoMsg: string; }

// /** payloads added by crystdata */
// export interface SelectTopTabItemPayload extends Partial<Payload> {
//   navId: string;
// }
export interface SelectNavItemPayload extends Partial<Payload> {
  navId: string;
}
export interface SetNavCollapsedPayload extends Partial<Payload> {
  collapse: boolean;
}
export interface SetAppLocalePayload extends Partial<Payload> {
  locale: string;
}
export interface SetDevicePickerVisiblePayload extends Partial<Payload> {
  visible: boolean;
}
// end of crystdata code
export interface SetQsgComponentIdPayload extends Partial<Payload> {
  qsgComponentId: CoreStoreState['qsgComponentId'];
}
export default {
  state: {
    appVersion: { version: '0.0.12', buildTime: '', gitCommit: null },
    pageViewWidth: 0,
    notificationCenterSlideVisible: false,
    federatedEmailExtensions: ['SNWLQA.ORG', 'LATTEDEV.COM', 'SONICWALL.COM', 'SOFTWARE.DELL.COM'],
    loading: false,
    userInfo: {},
    clientId: 'MUIR1XHIS27',
    userId: '',
    globalTheme: 'dark',
    helpContainerSlideVisible: false,
    alertSliderVisible: false,
    supportCaseSliderVisible : false,
    selectedHelpId: [],
    msgQueue: [],
    hideNavToggle: '',
    loggedIn: false,
    loggedInFromMSW: false,
    appVersionContent: {},
    // entry by crystdata
    appLocale: 'en-US',
    navCollapsed: false,
    selectedTopTabItemId: 'unifiedInsights',
    selectedNavItemId: 'dashboard',
    tenantName: '',
    tenant : '',
    devicePickerSlideVisible: false,
    deviceHierarchy: [],
    tenantList: [],
    arrTenantOptions: [],
    productList: [],
    tenantSerial: '',
    navigateUrl: '',
    tenantGroups: [],
    currentCcTenantId: '',
    nsmBaseUrl: '',
    ccBaseUrl: '',
    wirelessBaseUrl: '',
    nsmTenentMode: '',
    nsmTenentID: '',
    reloadWidgets: false,
    tfaMode: 'OFF',
    seletedTitle: {},
    cartCount: 0,
    pCLid: 'MUIR1XHIS27',
    // end of code by crystdata
    initial: {
      appVersion: { version: '0.0.12', buildTime: '', gitCommit: null },
      pageViewWidth: 0,
      notificationCenterSlideVisible: false,
      federatedEmailExtensions: ['SNWLQA.ORG', 'LATTEDEV.COM', 'SONICWALL.COM', 'SOFTWARE.DELL.COM'],
      loading: false,
      userInfo: {},
      clientId: 'MUIR1XHIS27',
      userId: '',
      globalTheme: 'dark',
      helpContainerSlideVisible: false,
      alertSliderVisible: false,
      supportCaseSliderVisible : false,
      selectedHelpId: [],
      msgQueue: [],
      hideNavToggle: '',
      loggedIn: false,
      loggedInFromMSW: false,
      appVersionContent: {},
      // entry by crystdata
      appLocale: 'en-US',
      navCollapsed: false,
      selectedTopTabItemId: 'unifiedInsights',
      selectedNavItemId: 'dashboard',
      tenantName: '',
      tenant : '',
      devicePickerSlideVisible: false,
      deviceHierarchy: [],
      tenantList: [],
      arrTenantOptions: [],
      productList: [],
      tenantSerial: '',
      navigateUrl: '',
      tenantGroups: [],
      currentCcTenantId: '',
      nsmBaseUrl: '',
      ccBaseUrl: '',
      wirelessBaseUrl: '',
      nsmTenentMode: '',
      nsmTenentID: '',
    // end of code by crystdata
    },
    qsgComponentId: '',
    userList : [],
    browserTitle: [],
    isGuestBuyNowUser: isGuestUser() || false,
  },
  /*tslint:disable:function-name */
  mutations: {
    selectNavItem(state, payload) {
      state.selectedNavItemId = payload.navId;
    },
    toggleNav(state, payload) {
      state.navCollapsed = payload ? payload.collapse : !state.navCollapsed;
    },
    startLoading: state => state.loading = true,
    stopLoading: state => state.loading = false,
    updateUserInfo: (state, payload) => {
      if (payload) {
        state.userInfo = payload;
        if (JSON.parse(payload) && JSON.parse(payload).user && JSON.parse(payload).user.userId) {
          state.userId = JSON.parse(payload).user.userId;
        }
      }
    },
    [MUTATION_SELECT_TOP_TAB_ITEM](state, payload: SelectTopTabItemPayload) {
      state.selectedTopTabItemId = payload.navId;
    },
    [MUTATION_SET_NAV_COLLAPSED](state, payload?: SetNavCollapsedPayload) {
      state.navCollapsed = payload ? payload.collapse : !state.navCollapsed;
    },
    [MUTATION_STORE_PAGE_VIEW_WIDTH](state, payload: StorePageViewWidthPayload) {
      state.pageViewWidth = payload.width;
    },
    [MUTATION_SET_HELP_CONTAINER_SLIDE_VISIBLE](state, payload: SetHelpContainerSlideVisiblePayload) {
      state.helpContainerSlideVisible = payload.visible;
    },
    [MUTATION_SET_ALERT_CONTAINER] (state, payload: SetAlertSliderVisiblePayload) {
      state.alertSliderVisible = payload.visible;
    },
    [MUTATION_SET_SUPPORT_CASE_CONTAINER] (state, payload: SetSupportCasesSliderVisiblePayload) {
      state.supportCaseSliderVisible = payload.visible;
    },
    [MUTATION_SET_HELP_CONTENT_ID](state, payload: SetHelpContentIdPayload) {
      state.selectedHelpId = payload.helpId;
    },
    [MUTATION_SET_TFA_MODE](state, payload: SetTFAModePayload) {
      state.tfaMode = payload.mode;
    },
    mutate: (state: any, payload) => state[payload.property] = payload.with,
    enqueueMessage(state, payload: InfoState) {
      state.msgQueue.unshift(payload);
    },
    clearEnqueMessage(state) {
      state.msgQueue  = [];
    },
    displayMessage(state, payload: InfoState) {
      state.msgQueue = [payload];
    },
    removeMessage(state, index) {
      state.msgQueue.splice(index, 1);
    },
    toggleHideNav(state, hideNav) {
      state.hideNavToggle = hideNav === 'APP' ? 'APP' : '';
    },
    assigner(state: any, payload) {
      try { state.appVersion; } catch (e) { }
      state[payload] = state.initial[payload];
    },
    loggedInFromMSWToggler(state: any) {
      state.loggedInFromMSW = !state.loggedInFromMSW;
    },
    setAppVersionContent(state: any, payload) {
      state.appVersionContent = payload;
    },
    // mutations added by crystdata

    [MUTATION_SET_APP_LOCALE](state, payload: SetAppLocalePayload) {
      state.appLocale = payload.locale;
    },
    [MUTATION_SELECT_TOP_TAB_ITEM](state, payload: SelectTopTabItemPayload) {
      state.selectedTopTabItemId = payload.navId;
    },
    // [MUTATION_SELECT_NAV_ITEM](state, payload: SelectNavItemPayload) {
    //   state.selectedNavItemId = payload.navId;
    // },
    [MUTATION_SET_NAV_COLLAPSED](state, payload?: SetNavCollapsedPayload) {
      state.navCollapsed = payload ? payload.collapse : !state.navCollapsed;
    },
    setDevicePickerSlideVisible(state, payload: SetDevicePickerVisiblePayload) {
      state.devicePickerSlideVisible = payload.visible;
    },
    setDeviceHierarchy(state, data) {
      state.deviceHierarchy = [...data];
    },
    setTenant(state, data) {
      state.tenant = data;
    },
    setTenantName(state, data) {
      state.tenantName = data;
    },
    setTenantList(state, data) {
      state.tenantList = [...data];
    },
    setArrTenantOptions(state, data) {
      state.arrTenantOptions = [...data];
    },
    setProductList(state, data) {
      state.productList = [...data];
    },
    setTenantSerial(state, data) {
      state.tenantSerial = data;
    },
    setNavigateUrl(state, data) {
      state.navigateUrl = data;
    },
    setTenantGroups(state, data) {
      state.tenantGroups = [...data];
    },
    setCurrentCcTenantId(state, data) {
      state.currentCcTenantId = data;
    },
    setNsmBaseUrl(state, data) {
      state.nsmBaseUrl = data;
    },
    setCcBaseUrl(state, data) {
      state.ccBaseUrl = data;
    },
    setWirelessBaseUrl(state, data) {
      state.wirelessBaseUrl = data;
    },
    setUserList(state , data) {
      state.userList = data;
    },
    setNsmTenentMode(state, data) {
      state.nsmTenentMode = data;
    },
    setNsmTenentID(state, data) {
      state.nsmTenentID = data;
    },
    // code end of crystdata
    [MUTATION_SET_QSG_COMPONENT_ID](state, payload: SetQsgComponentIdPayload) {
      state.qsgComponentId = payload.qsgComponentId;
    },
    setReloadWidgets(state, data) {
      state.reloadWidgets = data;
    },
  },
  actions: {
    resetStore(context: ActionContext<CoreStoreState, RootStoreState>) {
      const keys = context.state.initial ? Object.keys(context.state.initial) : [];
      keys.forEach((stateT: any) => {
        if (stateT !== 'initial') context.commit('assigner', stateT);
      });
    },
    isFederatedUser(context: ActionContext<CoreStoreState, RootStoreState>, userName: string) {
      context.commit('startLoading');
      const endpoint = `get-federated?user=${userName}`;
      return ApiServiceWrapper.get(endpoint);
    },
    toggleHideNavFunction(context: ActionContext<CoreStoreState, RootStoreState>, hideNav: string) {
      context.commit('toggleHideNav', hideNav);
    },
    viewCurrentMXRecord(context: ActionContext<CoreStoreState, RootStoreState>, selectedSer: string) {
      context.commit('startLoading');
      const endpoint = `product/hes-mxrecords-details?serial=${selectedSer}`;
      const requestBody = {};
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    resetPassword(context: ActionContext<CoreStoreState, RootStoreState>, request: string) {
      context.commit('startLoading');
      const endpoint = 'product/reset-hes-password';
      return ApiServiceWrapper.post(endpoint, request);
    },
    getSideNavSiteMap({ }, userName: string) {
      // context.commit('startLoading');
      const endpoint = `users/sitemap?username=${userName}&mode=VUE`;
      return ApiServiceWrapper.get(endpoint);
    },
    getToken(context: ActionContext<CoreStoreState, RootStoreState>, requestBody: any) {
      context.commit('startLoading');
      const endpoint = 'token';
      requestBody.password = jsEncrypt
        .getEncryptObj_msw()
        .encrypt(requestBody.password);
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    getTokenForSpog(context: ActionContext<CoreStoreState, RootStoreState>, requestBody: any) {
      context.commit('startLoading');
      const endpoint = 'token';
      // requestBody.password = jsEncrypt
      //   .getEncryptObj_spog()
      //   .encrypt(requestBody.password);
      requestBody.password = jsEncrypt
        .getEncryptObj_msw()
        .encrypt(requestBody.password);
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    logout(context: ActionContext<CoreStoreState, RootStoreState>, requestBody: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'log-out';
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    verifyTFA(context: ActionContext<CoreStoreState, RootStoreState>, requestBody: any) {
      context.commit('startLoading');
      const endpoint = 'tfa';
      requestBody.password = jsEncrypt
        .getEncryptObj_msw()
        .encrypt(requestBody.password);
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    sendEmail(context: ActionContext<CoreStoreState, RootStoreState>, requestBody: any) {
      context.commit('startLoading');
      const endpoint = 'tfa/send-email';
      requestBody.password = jsEncrypt
        .getEncryptObj_msw()
        .encrypt(requestBody.password);
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    getCaptcha(context: ActionContext<CoreStoreState, RootStoreState>) {
      context.commit('startLoading');
      const endpoint = 'captcha-details';
      return ApiServiceWrapper.get(endpoint);
    },
    /* tslint:disable-next-line */
    getNotifyCount(context: ActionContext<CoreStoreState, RootStoreState>, requestBody: any) {
      const endpoint = `users/get-notification-count?username=${requestBody}`;
      return ApiServiceWrapper.get(endpoint);
    },
    // updateCartCount(context: ActionContext<CoreStoreState, RootStoreState>) {
    //   const  count: any = localStorage.getItem('cartCount') &&
    //     localStorage.getItem('cartCount') !== null &&
    //     localStorage.getItem('cartCount') !== undefined ?
    //     localStorage.getItem('cartCount') : '';
    //   if (count && count !== '' && count !== undefined) {
    //     context.commit('mutate', { property: 'cartCount', with: +count });
    //   }
    // },
    preserveUserInfo(context: ActionContext<CoreStoreState, RootStoreState>, res: any, landingpage: any = 'm/feature/dashboard') {
      const loginInfo = {
        success: true,
        messageCode: res.msgCode,
        message: res.msgDesc,
        landingPage: landingpage,
        deviceCode: res.content.deviceCode,
        defaultApp: res.content.defaultApplication,
        isFreeTrial: res.content.isFreeTrial,
        user: {
          userId: res.content.userName,
          email: res.content.emailAddress,
          displayName: res.content.givenName,
          token: res.content.token,
          sessionId: res.content.sId,
          tfa: res.content.TFA,
          roles: res.content.roles,
          showRegisterPopup: res.content.showRegisterPopup,
          spogUser: res.content.spogUser,
          refreshToken : res.content.refreshToken ? res.content.refreshToken : '',
        },
        showRememberMe: res.content.showRememberMe,
      };
      if (window.location.hostname.toLowerCase()
        .indexOf('cloud.sonicwall') >= 0 || window.location.hostname.toLowerCase()
          .indexOf('cloud.eng.sonicwall') >= 0) {
        loginInfo.user.spogUser = true;
      }
      window.location.href.indexOf('msw.eng.sonicwall.com') > -1 ? context.commit('loggedInFromMSWToggler') : () => { };
      context.commit('updateUserInfo', JSON.stringify(loginInfo));
      localStorage.setItem(currentUserKey, JSON.stringify(loginInfo.user));
      localStorage.setItem('analytic', JSON.stringify(loginInfo.user));
    },
    removeUserInfo(context: ActionContext<CoreStoreState, RootStoreState>) {
      context.commit('updateUserInfo', '');
      localStorage.removeItem(currentUserKey);
      localStorage.removeItem('analytic');
    },
    stopLoading: context => context.commit('stopLoading'),
    navigateTo({ }, url: string) {
      console.warn('calling this');
      const currentUser = localStorage.getItem(currentUserKey);
      const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
      let redirectURL = '';
      if (envCongif.isDiffServerForContemporary) {
        const base64encodeRedirectURL = btoa(`${envCongif.contemporary_url}/${url}`);
        redirectURL = `${envCongif.contemporary_url}/login?tok=${token}&mode=${envCongif.leftNavMode}&REDIRECTPAGE=${base64encodeRedirectURL}`;
      } else {
        redirectURL = `${envCongif.contemporary_url}/${url}`;
      }
      // window.open(redirectURL, '_blank');
      window.top.location.assign(redirectURL);
    },
    navigateReplaceTo({ }, url: string) {
      const currentUser = localStorage.getItem(currentUserKey);
      const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
      let redirectURL = '';
      if (envCongif.isDiffServerForContemporary) {
        const base64encodeRedirectURL = btoa(`${envCongif.contemporary_url}/${url}`);
        redirectURL = `${envCongif.contemporary_url}/login?tok=${token}&mode=${envCongif.leftNavMode}&REDIRECTPAGE=${base64encodeRedirectURL}`;
      } else {
        redirectURL = `${envCongif.contemporary_url}/${url}`;
      }
      // window.open(redirectURL, '_blank');
      window.location.replace(redirectURL);
    },
    navigateToClassic(context: ActionContext<CoreStoreState, RootStoreState>, url: string) {
      const currentUser = localStorage.getItem(currentUserKey);
      const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
      let redirectURL = '';
      if (envCongif.isDiffServerForContemporary) {
        const base64encodeRedirectURL = btoa(`${envCongif.contemporary_url.replace('/muir', '')}/${url}`);
        redirectURL = `${envCongif.contemporary_url}/login?tok=${token}&mode=${envCongif.leftNavMode}&REDIRECTPAGE=${base64encodeRedirectURL}`;
      } else {
        redirectURL = `${envCongif.contemporary_url.replace('/muir', '')}/${url}`;
        const sessionId = JSON.parse(context.state.userInfo).user.sessionId;
        if (redirectURL.indexOf('?') === -1) {
          redirectURL = `${redirectURL}?I=${btoa(sessionId)}`;
        } else {
          redirectURL = `${redirectURL}&I=${btoa(sessionId)}`;
        }
      }
      window.top.location.assign(redirectURL);
    },
    getAppVersion({ }) {
      const endpoint = 'version';
      return ApiServiceWrapper.get(endpoint);
    },
    sendFeedback(context: ActionContext<CoreStoreState, RootStoreState>, requestBody: any) {
      context.commit('startLoading');
      const endpoint = 'users/save-delighted-feedback';
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    getLicenseKeySetVersions(context: ActionContext<CoreStoreState, RootStoreState>, requestURL) {
      context.commit('startLoading');
      return ApiServiceWrapper.get(requestURL);
    },
    getSpikeLicenceInfo(context: ActionContext<CoreStoreState, RootStoreState>, requestURL) {
      context.commit('startLoading');
      return ApiServiceWrapper.get(requestURL);
    },
    getLicenseKeySet(context: ActionContext<CoreStoreState, RootStoreState>, requestURL) {
      context.commit('startLoading');
      return ApiServiceWrapper.get(requestURL);
    },
    tologinPage44({ }) {
      window.location.assign(`${envCongif.contemporary_url}/ui/login`);
    },
    getIDPUrl({}, payload: any) {
      const endpoint = 'getidpurl';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    exchangeCodeForToken(context: ActionContext<CoreStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading');
      const endpoint = 'exchange-cscaccesscode';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    clearSiteMapCache(context: ActionContext<CoreStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endPoint = 'sandbox/admin/clear-sitemap';
      return ApiServiceWrapper.post(endPoint, payload);
    },
    getBrowserTitles(context: ActionContext<CoreStoreState, RootStoreState>, route : any) {
      let selectedTitle: BrowserTitlesConfig = {};
      let tempArray: BrowserTitlesConfig[] = [];
      tempArray = context.state.browserTitle.filter((browserTitle : BrowserTitlesConfig) => {
        return route.path.indexOf(browserTitle!.path!.toString()) > -1 &&
               route.query.tab &&
               route.query.tab === browserTitle!.tab;
      });
      if (tempArray.length > 0) {
        selectedTitle = tempArray[0];
      } else {
        selectedTitle = context.state.browserTitle.filter((browserTitle : BrowserTitlesConfig) => {
          return route.path.indexOf(browserTitle!.path!.toString()) > -1;
        })[0];
      }
      const DEFAULT_TITLE = 'My Sonicwall';
      (window as { [key: string]: any }).document.title = selectedTitle?.title || DEFAULT_TITLE;
      context.commit('mutate', { property: 'seletedTitle', with: { ...selectedTitle } });
    },
    getApplications(context: ActionContext<CoreStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'getapplications?ismatrix=YES';
      return ApiServiceWrapper.get(endpoint);
    },
    /* tslint:disable-next-line */
    openURLInNextTab(context: ActionContext<CoreStoreState, RootStoreState>, payload: string) {
      window.open(payload, '_blank');
    },
    // logOutMSW(context: ActionContext<CoreStoreState, RootStoreState>, payload : any) {
    //   context.commit('startLoading', null, { root: true });
    //   const endpoint = 'log-out';
    //   return ApiServiceWrapper.post(endpoint, payload);
    // },
  },
  getters: {
    loading: state => state.loading,
    appVersion: state => state.appVersion,
    isFederatedEmail: state => (emailId: string) => {
      return state.federatedEmailExtensions.indexOf(emailId.toUpperCase()) !== -1;
    },
    getUserId: state => state.userId,
    getUserInfo: state => state.userInfo,
    getClientId: state => state.clientId,
    effectivePageTheme: state => state.globalTheme,
    getMsgQueue: state => state.msgQueue,
    getHideNavStatus: state => state.hideNavToggle,
    getloggedInFromMSWValue: state => state.loggedInFromMSW,
    getUserList : state => state.userList,
    indexedDbWaitList: (state) => { // tslint:disable-line
      // @ts-ignore
      const data: string = localStorage.getItem('idbWaitList') ? localStorage.getItem('idbWaitList') : '[]';
      return JSON.parse(data);
    },
    isLargeCustomer: state => localStorage.getItem('isLargeCustomer') === 'YES' ? true : false, // tslint:disable-line
    getQsgComponentId(state): string {
      return state.qsgComponentId;
    },
    getPageTitle: state => state.seletedTitle,
    getBrowserList: state => state.browserTitle,
    getpCLidFromStore: state => state.pCLid,
    isGuestBuyNowUser: state => state.isGuestBuyNowUser,
  },
  /*tslint:enable:function-name */
} as Module<CoreStoreState, RootStoreState>;
